import {
  DownloadLifestylesSetGqlQuery,
  DownloadLifestylesSetGqlStatus,
  LifestylesSetDeviceNanoId,
  LifestylesSetGqlError,
  LifestylesSetUUID
} from '../../lifestylesSetsTypes';

import { useUpdateQuery } from '../../../common/reactQuery/hooks/useUpdateQuery';

interface DownloadLifestylesSetOptions {
  query: DownloadLifestylesSetGqlQuery;
  cacheKeys?: string[];
}

export interface DownloadLifestylesSetResponse<
  DownloadLifestylesSetRecordType
> {
  downloadLifestylesSet: {
    status: DownloadLifestylesSetGqlStatus;
    recordUuid: LifestylesSetUUID;
    record: DownloadLifestylesSetRecordType;
    errors: DownloadLifestylesSetError;
  };
}

export interface DownloadLifestylesSetInput {
  uuid: LifestylesSetUUID;
  deviceNanoId: LifestylesSetDeviceNanoId;
}

export interface DownloadLifestylesSetError {
  fullMessages: LifestylesSetGqlError;
}

const action = 'downloadLifestylesSet';

function useDownloadLifestylesSet<DownloadLifestylesSetRecordType>({
  query,
  cacheKeys
}: DownloadLifestylesSetOptions) {
  const {
    updateQueryData,
    updateQuery,
    updateQueryReset,
    updateQueryError,
    updateQueryLoading,
    updateQueryErrorMessage
  } = useUpdateQuery<
    DownloadLifestylesSetInput,
    DownloadLifestylesSetResponse<DownloadLifestylesSetRecordType>,
    DownloadLifestylesSetError,
    DownloadLifestylesSetRecordType
  >({ action, query, cacheKeys });

  return {
    downloadLifestylesSetData: updateQueryData,
    downloadLifestylesSetError: updateQueryError,
    downloadLifestylesSetLoading: updateQueryLoading,
    downloadLifestylesSetErrorMessage: updateQueryErrorMessage,
    downloadLifestylesSet: updateQuery,
    downloadLifestylesSetReset: updateQueryReset
  };
}

export default useDownloadLifestylesSet;
